import Button, { type ButtonProps } from './Button';
export { Button as default, Button, ButtonProps };